module.exports = __webpack_public_path__ + "static/img/bg1.1b305e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/bg1.jpg
// module id = GaTJ
// module chunks = 9